const SUMMARY_TYPES = {
    GET_TASK_SUMMARY: "GET_TASK_SUMMARY",
    GET_TASK_SUMMARY_LOADING: "GET_TASK_SUMMARY_LOADING",
    GET_TASK_SUMMARY_SUCCESS: "GET_TASK_SUMMARY_SUCCESS",
    GET_TASK_SUMMARY_ERROR: "GET_TASK_SUMMARY_ERROR",
    GET_TASK_SUMMARY_RESET: "GET_TASK_SUMMARY_RESET",

    GET_PRIORITY_GRAPH: "GET_PRIORITY_GRAPH",
    GET_PRIORITY_GRAPH_LOADING: "GET_PRIORITY_GRAPH_LOADING",
    GET_PRIORITY_GRAPH_SUCCESS: "GET_PRIORITY_GRAPH_SUCCESS",
    GET_PRIORITY_GRAPH_ERROR: "GET_PRIORITY_GRAPH_ERROR",
    GET_PRIORITY_GRAPH_RESET: "GET_PRIORITY_GRAPH_RESET",

    GET_TASK_WEEK_COUNT: "GET_TASK_WEEK_COUNT",
    GET_TASK_WEEK_COUNT_LOADING: "GET_TASK_WEEK_COUNT_LOADING",
    GET_TASK_WEEK_COUNT_SUCCESS: "GET_TASK_WEEK_COUNT_SUCCESS",
    GET_TASK_WEEK_COUNT_ERROR: "GET_TASK_WEEK_COUNT_ERROR",
    GET_TASK_WEEK_COUNT_RESET: "GET_TASK_WEEK_COUNT_RESET",

    GET_ALL_TASK_COUNT: "GET_ALL_TASK_COUNT",
    GET_ALL_TASK_COUNT_LOADING: "GET_ALL_TASK_COUNT_LOADING",
    GET_ALL_TASK_COUNT_SUCCESS: "GET_ALL_TASK_COUNT_SUCCESS",
    GET_ALL_TASK_COUNT_ERROR: "GET_ALL_TASK_COUNT_ERROR",
    GET_ALL_TASK_COUNT_RESET: "GET_ALL_TASK_COUNT_RESET",
};

export default SUMMARY_TYPES;
